/* eslint-disable no-else-return */
import { useEffect, useState } from 'react';
import { getRecommendCountry } from '@/api/geo/index';

export default function useCountryCode() {
    const [areas, setAreas] = useState([]);
    const [countries, setCountries] = useState([]);
    const [recommendCountry, setRecommendCountry] = useState('');

    useEffect(() => {
        getRecommendCountry().then((res: any) => {
            const { data: { areaList = [], recommendCountry = {}, stateList = [] } = {} } = res;

            // 获取国家列表
            const countries = areaList.map((item: any) => {
                return item.name === 'other'
                    ? {
                          ...item,
                          label: item.name,
                          key: `area_${item.name}`,
                      }
                    : {
                          ...item,
                          label: item.name,
                      };
            });

            // 获取国家地区列表
            const areasCode = areaList
                .filter((item: any) => item.value !== 'US')
                .map((item: any) => {
                    return item.name === 'other'
                        ? {
                              ...item,
                              label: item.name,
                              key: `area_${item.name}`,
                          }
                        : {
                              ...item,
                              label: item.name,
                          };
                });
            const stateCode = (stateList || []).map((item: any) => {
                return {
                    ...item,
                    label: item.name,
                };
            });
            let areas =
                stateList?.length > 0 ? [...areasCode, ...stateCode] : [...countries, ...stateCode];
            areas = areas.sort((a: any, b: any) => {
                if (a.label < b.label) {
                    return -1;
                } else if (a.label > b.label) {
                    return 1;
                } else {
                    return 0;
                }
            });

            setAreas(areas as any);
            setCountries(countries as any);
            setRecommendCountry(recommendCountry);
        });
    }, []);

    return {
        areas,
        countries,
        recommendCountry,
    };
}
